import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-health-check-modal',
  templateUrl: './health-check-modal.component.html',
  styleUrl: './health-check-modal.component.scss'
})
export class HealthCheckModalComponent {
   @Input() healthCheckData: any;
   objectKeys = Object.keys;                 // convenience for *ngFor

  constructor(private modalCtrl: ModalController) {}

  
  dismiss() {
    this.modalCtrl.dismiss();
  }

  get dependencyNames(): string[] {
    return Object.keys(this.healthCheckData?.DependencyHealthChecks ?? {});
  }
}
